import { useDispatch } from 'react-redux'

import { AppDispatchNext } from 'actions/actions.typesNext'

export const useAppDispatch = () => {
  return useDispatch<AppDispatchNext>()
}
